/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Strategia di ordinamento per richieste con stesso punteggio
 */
export enum OrdinamentoPariPunteggio {

    V1 = 'V1',

    V2 = 'V2',

    V3 = 'V3',

    V4 = 'V4',

    PUNTEGGIO_TEMPO = 'PUNTEGGIO_TEMPO'
}

